// @flow
import type {
  ConfigFormState,
} from './types';

type GlobalState = {
  configuration: {
    configForm: ConfigFormState,
  },
};

const getReducer = (state: GlobalState): ConfigFormState => state.configuration.configForm;

type Loading = $PropertyType<ConfigFormState, 'loading'>;
export const isLoading = (state: GlobalState): Loading => (
  getReducer(state).loading
);

type Error = $PropertyType<ConfigFormState, 'error'>;
export const hasError = (state: GlobalState): Error => (
  getReducer(state).error
);

type Saved = $PropertyType<ConfigFormState, 'saved'>;
export const hasSaved = (state: GlobalState): Saved => (
  getReducer(state).saved
);

type ErrorResponse = $PropertyType<ConfigFormState, 'errorResponse'>;
export const getErrorResponse = (state: GlobalState): ErrorResponse => (
  getReducer(state).errorResponse
);

type LoginHash = $PropertyType<ConfigFormState, 'loginHash'>;
export const getLoginHash = (state: GlobalState): LoginHash => (
  getReducer(state).loginHash
);
